//adpated version of https://github.com/Adphorus/react-date-range/blob/master/src/defaultRanges.js
import { addDays, addWeeks, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek, isSameDay, isThisWeek, isFuture, differenceInMonths, differenceInWeeks, format, addYears, startOfYear, differenceInYears, endOfYear, isThisYear, isMonday } from "date-fns";
export const getDefinedDates = () => {
  return {
    limitlessStartDate: new Date(2017, 0, 1),
    limitlessStartWeek: new Date(2017, 0, 2),
    startOfWeek: startOfWeek(new Date(), {
      weekStartsOn: 1
    }),
    endOfWeek: new Date(),
    startOfLast6Days: addDays(new Date(), -6),
    startOfLast7Days: addDays(new Date(), -7),
    startOfLast28Days: addDays(new Date(), -28),
    startOfLast27Days: addDays(new Date(), -27),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7), {
      weekStartsOn: 1
    }),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7), {
      weekStartsOn: 1
    }),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: new Date(),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfLast3Months: startOfMonth(addMonths(new Date(), -3)),
    startOfLast6Months: startOfMonth(addMonths(new Date(), -6)),
    startOfLast9Months: startOfMonth(addMonths(new Date(), -9)),
    startOfLast12Months: startOfMonth(addMonths(new Date(), -12)),
    startOfLast24Months: startOfMonth(addMonths(new Date(), -24)),
    startOfLast4Weeks: startOfWeek(addWeeks(new Date(), -4), {
      weekStartsOn: 1
    }),
    startOfLast12Weeks: startOfWeek(addWeeks(new Date(), -12), {
      weekStartsOn: 1
    }),
    startOfLast26Weeks: startOfWeek(addWeeks(new Date(), -26), {
      weekStartsOn: 1
    }),
    startOfLast52Weeks: startOfWeek(addWeeks(new Date(), -52), {
      weekStartsOn: 1
    }),
    startOfThisYear: startOfYear(new Date()),
    startOfLastYear: startOfYear(addYears(new Date(), -1)),
    endOfLastYear: endOfYear(addYears(new Date(), -1)),
    endOfThisWeek: isThisWeek(endOfDay(addDays(new Date(), -1)), {
      weekStartsOn: 1
    }) && !isFuture(endOfDay(addDays(new Date(), -1))) ? endOfDay(addDays(new Date(), -1)) : startOfWeek(new Date(), {
      weekStartsOn: 1
    }),
    startOfTomorrow: startOfDay(addDays(new Date(), 1)),
    endOfTomorrow: endOfDay(addDays(new Date(), 1)),
    startOfNextMonth: startOfMonth(addMonths(new Date(), 1)),
    endOfNextMonth: endOfMonth(addMonths(new Date(), 1)),
    endOfNext2Days: endOfDay(addDays(new Date(), 2)),
    endOfNext7Days: endOfDay(addDays(new Date(), 6)),
    endOfNext8Days: endOfDay(addDays(new Date(), 7)),
    startOf2DaysAgo: startOfDay(addDays(new Date(), -2)),
    endOf2DaysAgo: endOfDay(addDays(new Date(), -2)),
    startOf2WeeksAgo: startOfWeek(addDays(new Date(), -14), {
      weekStartsOn: 1
    }),
    endOf2WeeksAgo: endOfWeek(addDays(new Date(), -14), {
      weekStartsOn: 1
    }),
    startOf2MonthsAgo: startOfMonth(addMonths(new Date(), -2)),
    endOf2MonthsAgo: endOfMonth(addMonths(new Date(), -2))
  };
};
const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return isSameDay(range.startDate, definedRange.startDate) && isSameDay(range.endDate, definedRange.endDate);
  }
};
const createStaticRanges = ranges => {
  const newRanges = [];
  ranges.map(range => {
    if (range.label) {
      newRanges.push({
        ...staticRangeHandler,
        ...range
      });
    }
  });
  return newRanges;
};
export const CM_MESSAGE_EXPORT_STATIC_RANGES = createStaticRanges([{
  label: "Today",
  range: () => ({
    startDate: getDefinedDates().startOfToday,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Yesterday",
  range: () => ({
    startDate: getDefinedDates().startOfYesterday,
    endDate: getDefinedDates().endOfYesterday
  })
}, {
  label: "Last 7 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast6Days,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: getDefinedDates().startOfLastWeek,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 28 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast27Days,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: getDefinedDates().startOfLastMonth,
    endDate: getDefinedDates().endOfLastMonth
  })
}]);
export const CM_DAILY_STATIC_RANGES = createStaticRanges([{
  label: "Today",
  range: () => ({
    startDate: getDefinedDates().startOfToday,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Yesterday",
  range: () => ({
    startDate: getDefinedDates().startOfYesterday,
    endDate: getDefinedDates().endOfYesterday
  })
}, {
  label: "Last 7 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast6Days,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: getDefinedDates().startOfLastWeek,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 28 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast27Days,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: getDefinedDates().startOfLastMonth,
    endDate: getDefinedDates().endOfLastMonth
  })
}]);
export const KNOWLEDGE_DAILY_STATIC_RANGES = createStaticRanges([{
  label: "Tomorrow",
  range: () => ({
    startDate: getDefinedDates().startOfTomorrow,
    endDate: getDefinedDates().endOfTomorrow
  })
}, {
  label: "Next 2 Days",
  range: () => ({
    startDate: getDefinedDates().startOfTomorrow,
    endDate: getDefinedDates().endOfNext2Days
  })
}, {
  label: "Next 7 Days",
  range: () => ({
    startDate: getDefinedDates().startOfTomorrow,
    endDate: getDefinedDates().endOfNext8Days
  })
}, {
  label: "Next Month",
  range: () => ({
    startDate: getDefinedDates().startOfNextMonth,
    endDate: getDefinedDates().endOfNextMonth
  })
}]);
const createWeekToDate = () => {
  if (!isMonday(new Date())) {
    return {
      label: "Week To Date",
      range: () => ({
        startDate: getDefinedDates().startOfWeek,
        endDate: getDefinedDates().endOfWeek
      })
    };
  }
  return {};
};
export const REPORTING_DAILY_STATIC_RANGES = createStaticRanges([{
  label: "Today",
  range: () => ({
    startDate: getDefinedDates().startOfToday,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Yesterday",
  range: () => ({
    startDate: getDefinedDates().startOfYesterday,
    endDate: getDefinedDates().endOfYesterday
  })
}, createWeekToDate(), {
  label: "Last 7 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast7Days,
    endDate: getDefinedDates().endOfYesterday
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: getDefinedDates().startOfLastWeek,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Month to Date",
  range: () => ({
    startDate: getDefinedDates().startOfMonth,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Last 28 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast27Days,
    endDate: getDefinedDates().endOfToday
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: getDefinedDates().startOfLastMonth,
    endDate: getDefinedDates().endOfLastMonth
  })
}]);
export const DAILY_STATIC_RANGES = createStaticRanges([{
  label: "Yesterday",
  range: () => ({
    startDate: getDefinedDates().startOfYesterday,
    endDate: getDefinedDates().endOfYesterday
  })
}, {
  label: "Last 7 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast7Days,
    endDate: getDefinedDates().endOfYesterday
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: getDefinedDates().startOfLastWeek,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 28 Days",
  range: () => ({
    startDate: getDefinedDates().startOfLast28Days,
    endDate: getDefinedDates().endOfYesterday
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: getDefinedDates().startOfLastMonth,
    endDate: getDefinedDates().endOfLastMonth
  })
}]);
export const WEEKLY_STATIC_RANGES = createStaticRanges([{
  label: "This Week",
  range: () => ({
    startDate: getDefinedDates().startOfWeek,
    endDate: getDefinedDates().endOfWeek
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: getDefinedDates().startOfLastWeek,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 4 Weeks",
  range: () => ({
    startDate: getDefinedDates().startOfLast4Weeks,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 12 Weeks",
  range: () => ({
    startDate: getDefinedDates().startOfLast12Weeks,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 26 Weeks",
  range: () => ({
    startDate: getDefinedDates().startOfLast26Weeks,
    endDate: getDefinedDates().endOfLastWeek
  })
}, {
  label: "Last 52 Weeks",
  range: () => ({
    startDate: getDefinedDates().startOfLast52Weeks,
    endDate: getDefinedDates().endOfLastWeek
  })
}]);
export const MONTHLY_STATIC_RANGES = createStaticRanges([{
  label: "This Month",
  range: () => ({
    startDate: getDefinedDates().startOfMonth,
    endDate: getDefinedDates().endOfMonth
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: getDefinedDates().startOfLastMonth,
    endDate: getDefinedDates().endOfLastMonth
  })
}, {
  label: "Last 3 Months",
  range: () => ({
    startDate: getDefinedDates().startOfLast3Months,
    endDate: getDefinedDates().endOfLastMonth
  })
}, {
  label: "Last 6 Months",
  range: () => ({
    startDate: getDefinedDates().startOfLast6Months,
    endDate: getDefinedDates().endOfLastMonth
  })
}, {
  label: "Last 9 Months",
  range: () => ({
    startDate: getDefinedDates().startOfLast9Months,
    endDate: getDefinedDates().endOfLastMonth
  })
}, {
  label: "Last 12 Months",
  range: () => ({
    startDate: getDefinedDates().startOfLast12Months,
    endDate: getDefinedDates().endOfLastMonth
  })
}, {
  label: "Last 24 Months",
  range: () => ({
    startDate: getDefinedDates().startOfLast24Months,
    endDate: getDefinedDates().endOfLastMonth
  })
}]);
export const getWeeklyList = (endOfDuration = false) => {
  const numOfWeeks = differenceInWeeks(getDefinedDates().startOfYesterday, getDefinedDates().limitlessStartWeek);
  const weekList = [];

  //+ 1 to compensate for the way date-fns calculates full weeks
  for (let i = 0; i < numOfWeeks + 1; i++) {
    let week = "";
    if (endOfDuration) {
      week = addDays(addWeeks(getDefinedDates().limitlessStartWeek, i), 6);
    } else {
      week = addWeeks(getDefinedDates().limitlessStartWeek, i);
    }
    //we take the middle of the week for displaying as it could be te week falls across 2 years.
    const displayWeek = addDays(addWeeks(getDefinedDates().limitlessStartWeek, i), 3);
    weekList.push({
      label: format(displayWeek, "wk W YYYY"),
      value: week
    });
  }
  return weekList.reverse();
};
export const getMonthlyList = (endOfDuration = false) => {
  const numOfMonths = differenceInMonths(getDefinedDates().startOfYesterday, getDefinedDates().limitlessStartDate);
  const monthList = [];
  //+ 1 to include the current month
  for (let i = 0; i < numOfMonths + 1; i++) {
    let month = addMonths(getDefinedDates().limitlessStartDate, i);
    if (endOfDuration) {
      month = endOfMonth(month);
    }
    monthList.push({
      label: format(month, "MMM YYYY"),
      value: month
    });
  }
  return monthList.reverse();
};
export const getAnnualList = (endOfDuration = false) => {
  const numOfYears = differenceInYears(getDefinedDates().startOfYesterday, getDefinedDates().limitlessStartDate);
  const yearList = [];

  //+ 1 to compensate for the way date-fns calculates full years
  for (let i = 0; i < numOfYears + 1; i++) {
    let year = addYears(getDefinedDates().limitlessStartDate, i);
    if (endOfDuration) {
      if (isThisYear(year)) {
        year = getDefinedDates().endOfYesterday;
      } else {
        year = endOfYear(year);
      }
    }
    yearList.push({
      label: format(year, "YYYY"),
      value: year
    });
  }
  return yearList.reverse();
};